import moment from "moment";
import jsPDF from "jspdf";
import "jspdf-autotable";
import html2canvas from "html2canvas";

window.html2canvas = html2canvas;

export const ReportPdfFactory = path => filename => {
  const pdf = new jsPDF({
    orientation: 'p',
    unit: 'pt',
    format: 'letter'
  });

  const margins = {
    top: 36,
    right: 36,
    bottom: 36,
    left: 36,
  };

  pdf.setDocumentProperties({
    title: filename,
    author: 'cProject',
  });

  const printView = document.querySelector('#reports > div.ant-card');

  if (path === 'upcoming-bid-details'
    || path === 'daily-log-details'
    || path === 'meeting-minutes-details') {
    // jsPDF From HTML

    // Print report
    pdf.fromHTML(
      printView,
      margins.left,
      margins.top,
      {
        'width': pdf.internal.pageSize.getWidth() - margins.left - margins.right,
        'elementHandlers': { '#controls': () => true }
      },
      null,
      margins
    );

  } else {
    // jsPDF AutoTable

    const head = printView.querySelector('.ant-card-head');

    // Print header
    pdf.fromHTML(
      head,
      margins.left,
      margins.top,
      {
        'width': pdf.internal.pageSize.getWidth() - margins.left - margins.right,
        'elementHandlers': { '#controls': () => true }
      },
      null,
      margins
    );

    let options = window.options || {
      theme: 'grid',
      styles: { cellWidth: 100 },
      headStyles: {
        fillColor: Math.round(.9 * 255),
        textColor: 20,
        lineWidth: 1,
      },
      startY: margins.top + Math.floor(head.scrollHeight * 3 / 4),
      html: '#listElement table',
    };

    if (!window.options && path.includes('detail')) {
      options.styles.cellWidth = 60;
      options.columnStyles = {
        0: { cellWidth: 'auto' },
        1: { cellWidth: 140 },
      };
    }

    window.options = options;

    // Print table
    pdf.autoTable(window.options);

  }

  // Add page headers and footers
  pdf.internal.pages.forEach((page, index) => {
    pdf.setPage(index);
    pdf.setFontSize(8);
    pdf.setTextColor(0);
    pdf.text(margins.left, margins.top * 2 / 3, moment().format('M/D/YYYY'));
    pdf.text(pdf.internal.pageSize.getWidth() / 2, margins.top * 2 / 3, document.title);
    pdf.text(margins.left, pdf.internal.pageSize.getHeight() - margins.bottom * 2 / 3, window.location.href);
    pdf.text(pdf.internal.pageSize.getWidth() - 2 * margins.right, pdf.internal.pageSize.getHeight() - margins.bottom * 2 / 3, `${index}/${pdf.internal.pages.length}`);
  });

  pdf.save(filename.replace(/ /g, '').replace(/[^a-z0-9]/gi, '-'));
};



// WEBPACK FOOTER //
// ./src/components/Reports/ReportPdfFactory.js